/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:27
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-09 16:54:54
 */
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help.js"


class ELinkElement extends GraphElement {
  static fromJSON = createFromJSON(this)
  constructor(topology, x, y, attrs) {
    super(topology, 'eLink', x, y, {
      text: '能量链',
      port: true,
      ...attrs
    })

    this.onLoad(() => {
      this.prop_y = -10
      this.addProperty('功率', 'kW')
      // this.addProperty('无功功率', 'kvar')
      this.addProperty('电流', 'A')
      this.addProperty('电压', 'V')
      this.addProperty('SOC', '%', { fill: 'rgb(44, 213, 99)' })
    })
  }

  updateData(data) {
    this.updateProperty('功率', data.p_total)
    // this.updateProperty('无功功率', data.q_total)
    this.updateProperty('电流', data.i_a)
    this.updateProperty('电压', data.u_a)
    this.updateProperty('SOC', data.soc)
  }
}


export { ELinkElement }
